import { Component, OnInit } from '@angular/core';
import {UtilService} from "../../services/utilService/util.service";
import {IResponse, locales} from "../../interfaces/iresponse";
import {UserService} from "../../services/apiCalls/userService/user.service";
import {ActivatedRoute} from "@angular/router";
import {EventsService} from "../../services/eventServices/event.service";
import {BootstrapNotifyService} from "../../services/bootstrap-notify/bootstrap-notify.service";
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-agents',
  templateUrl: './agents.component.html',
  styleUrls: ['./agents.component.css']
})
export class AgentComponent implements OnInit {
  breadCrumb: any;
  myAgents: any[] = [];
  locals: Array<locales> = [];
  loadingLocales: boolean = false;
  loadingData = false;
  submitting: boolean =false;
  viewing: boolean =false;
  uniqueCode: string = '';
  currentUser: any;
  changeOccured = true;
  status = 1;
  actionId: number = 0;
  constructor(private utilService: UtilService,
              private route: ActivatedRoute,
              private eventService: EventsService,
              private alertService: BootstrapNotifyService,
              private userService: UserService) {
    this.currentUser = this.utilService.getAuthUser().owner || {};
    this.eventService.on('RERENDER_COMPONENT', (data) => {
      this.status = data;
      this.myAgents = [];
      this.currentUser = this.utilService.getAuthUser().owner;
      this.getAgents({approved: this.status});
      // this.ngOnInit();
    });
  }
  addAgentForm = new FormGroup({
    first_name: new FormControl('', Validators.required),
    last_name: new FormControl('', Validators.required),
    phone_no: new FormControl('', [Validators.required, Validators.maxLength(11), Validators.pattern('^[0-9]+$')]),
    lga_id: new FormControl('', Validators.required),
    email: new FormControl('', [Validators.required, Validators.email]),
  })

  getPhoneNumberError(): boolean{
    if(this.addAgentForm.get('phone_no').hasError('pattern') || this.addAgentForm.get('phone_no').hasError('maxlength')){
      return true;
    } 
    return false;
  }

  ngOnInit() {
    this.getZoneLocale();
    this.getUniqueCode()
    this.breadCrumb  = {
      name: 'Agents',
      parent: 'Home',
      subLink: null
    };
    const query: any = this.route.snapshot.queryParams;
    this.myAgents = [];
    if(query.status === 'inactive') {
      this.status = 0;
      this.getAgents({approved: this.status});
    } else if(query.status === 'active') {
      this.status = 1;
      this.getAgents({approved: this.status});
    } else if(!query.status){
      this.getAgents(null);
    } else {
      this.getAgents(null);
    }
  }

  getAgents(filter) {
    this.loadingData = true;
    this.changeOccured = false;
    this.actionId = 0;
    // let status = status || 1;
    this.userService.filterMyAgent(filter, this.currentUser.id)
      .subscribe((res: IResponse) => {
        this.myAgents = res.data;
        this.utilService.startDatatable('agents-lists');
        this.loadingData = false;
        this.changeOccured = true;
      }, error => {
        this.utilService.startDatatable('agents-lists');
        this.loadingData = false;
        this.changeOccured = true;
      });
  }
  toggleAgentStatus(agent, action) {
    this.actionId = agent.id;
    this.utilService.confirmAction(()=>{
      this.userService.toggleAgentStatus({action_type: action}, agent.id)
        .subscribe((res: IResponse) => {
          this.alertService.success(res.message);
          this.getAgents(null);
        }, error => {
          this.alertService.error(error.error.message || 'Unable to toggle agent status!');
        });
    }, ()=>{
      this.actionId = 0;
    })
  }

  addMerchant(){
    this.utilService.openModal('addagent');
  }

  getUniqueCode(){
    const code = this.utilService.getAuthUser();
    this.uniqueCode = code.owner.unique_code;
  }

  getZoneLocale(){
    this.loadingLocales = true
    return this.userService.getlocaleZones().subscribe({
      next: (response)=>{
        this.locals = response;
      }, error: (err)=>{
        const {messge} = err;
      }
    }
    ).add(()=> this.loadingLocales = false)
  }

 

  submitAgentForm(){
    if(this.addAgentForm.invalid){
      return;
    }
    const payload = {
      ...this.addAgentForm.value,
      status: 1,
      super_agent_code: this.uniqueCode,
      password: 'password',
      password_confirmation: 'password',
    }
    this.submitting = true;
    this.userService.createAgent(payload).subscribe({
      next: (response)=>{
        this.getAgents(null);
        this.utilService.closeModal('addagent');
        this.alertService.success(response.message);
      },
      error: (error)=>{
        this.alertService.error(error.error.message);
      }
    }).add(()=> this.submitting = false)
  }
}